/** The builder's pages, in order, with the heading each shows. */
export const BUILDER_STEPS = [
  { label: "Name", title: "Name your box and add an image" },
  { label: "Rules", title: "Choose which products can be inside" },
  { label: "Price", title: "Set your margin and price" },
] as const;
